module.exports = __webpack_public_path__ + "img/invest_list3.a19515c7.png";